



























import { Employe } from "../../models/Employe";
import Contrat = Employe.Contrat;
import NumeralInput from "../../core/Forms/NumeraInput.vue";
import DateInput from "../../core/Forms/DateInput.vue";

export default {
    name: "ContratModalEdit",
    components: { DateInput, NumeralInput },
    props: {
        contrat: Contrat,
    },
    data() {
        return {};
    },
};
